import React from "react";
import { MdLabelImportant, MdArrowRight } from "react-icons/md";
const EditorRenderer = ({ blocks }) => {

    console.log("block",blocks);
  if (!blocks || blocks.length === 0) return null;

  return (
    <div className="flex flex-col gap-4">
      {blocks.map((block, index) => {
        const { type, data } = block;

        // Wrapper card styles
        const cardClass = "bg-white rounded-md shadow-md p-6";

        switch (type) {
          case "header":
            return (
              <div key={index} className="sm:text-3xl text-2xl font-bold text-[#22BEFF] mt-4 flex items-center ">
                <MdLabelImportant className="sm:text-xl text-base"/>

                <h2
                  className={`text-${Math.min(data.level * 200, 900)} font-bold leading-tight`}
                  dangerouslySetInnerHTML={{ __html: data.text }}
                />
              </div>
            );

          case "paragraph":
            return (
              <div key={index} className="text-gray-400 text-xl text-justify">
                <p
                  className=" leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: data.text }}
                />
              </div>
            );

        case "list":
            return (
                <div key={index} className="text-base">
                {data.style === "unordered" ? (
                    <ul className="list-disc pl-6 text-gray-400 space-y-1 text-xl mb-2">
                    {data.items.map((item, i) => (
                        <li key={i}>
                        {typeof item === "object" ? item.content || item.text || JSON.stringify(item) : item}
                        </li>
                    ))}
                    </ul>
                ) : (
                    <ol className="list-decimal pl-6 text-gray-400 space-y-1 text-xl mb-2">
                    {data.items.map((item, i) => (
                        <li key={i} className="mb-4">
                        {typeof item === "object" ? item.content || item.text || JSON.stringify(item) : item}
                        </li>
                    ))}
                    </ol>
                )}
                </div>
            );



        case "table":
            return (
                <div key={index} className="overflow-x-auto pb-8 w-full">
                <table className="min-w-full border-collapse text-gray-400 text-sm">
                    <tbody>
                    {data.content.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                        {row.map((cell, cellIndex) =>
                            rowIndex === 0 ? (
                            <th
                                key={cellIndex}
                                className="border border-gray-300 text-gray-400 py-2 px-4 text-left sm:text-xl text-base"
                            >
                                {cell}
                            </th>
                            ) : (
                            <td
                                key={cellIndex}
                                className="border border-gray-300 text-gray-400 py-2 px-4 sm:text-xl text-base"
                            >
                                {cell}
                            </td>
                            )
                        )}
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            );


          case "image":
            return (
              <div key={index} className={`flex flex-col`}>
                <img
                  src={data.file?.url}
                  alt={data.caption || "Image"}
                  className="max-w-full sm:h-[30rem] object-cover rounded-md shadow-md"
                />
                {data.caption && (
                  <p className="mt-2 text-gray-500 text-sm italic">{data.caption}</p>
                )}
              </div>
            );

          case "code":
            return (
              <div key={index} >
                <pre className="bg-gray-900 text-green-400 p-4 rounded overflow-x-auto whitespace-pre-wrap">
                  <code>{data.code}</code>
                </pre>
              </div>
            );

          case "quote":
            return (
              <div key={index} className={` border-l-4 border-blue-500`}>
                <blockquote className="italic text-gray-800">
                  <p>{data.text}</p>
                  {data.caption && (
                    <footer className="mt-2 text-sm text-gray-500">— {data.caption}</footer>
                  )}
                </blockquote>
              </div>
            );

          case "delimiter":
            return (
              <div key={index} className={cardClass}>
                <hr className="border-gray-300" />
              </div>
            );

         case "checklist":
            return (
                <div key={index} className={cardClass}>
                <ul className="space-y-2">
                    {data.items.map((item, i) => (
                    <li
                        key={i}
                        className="flex items-center gap-3 text-gray-400 text-base"
                    >
                        <input
                        type="checkbox"
                        disabled
                        checked={!!item.checked}
                        className="form-checkbox h-5 w-5 text-blue-600"
                        />
                        <span>{item.text}</span>
                    </li>
                    ))}
                </ul>
                </div>
            );


          default:
            return null;
        }
      })}
    </div>
  );
};

export default EditorRenderer;
